import React from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { DeliverableGroups } from '../../components/DeliverableGroups';
export function Episodes() {
  const {
    activeProject
  } = usePortal();
  return <div data-id="element-559" data-mp="1cr1pt3sltnp7">
      <p className="label text-mute" data-id="element-560" data-mp="1cqrxh9k374gc">{activeProject.type}</p>
      <h1 className="mt-6 font-display text-5xl leading-[0.95] tracking-tight sm:text-7xl" data-id="element-561" data-mp="17t9xi8o1rzkh">
        DELIVERABLES
      </h1>
      <p className="mt-8 max-w-2xl font-display text-xl text-charcoal" data-id="element-562" data-mp="12u6vyy7a0bh9">
        Everything planned for this project, grouped by where it currently sits. Open anything in
        review to watch the latest version, request changes or approve it. Approved deliverables
        move to Files.
      </p>

      <div className="mt-16 border-t border-rule pt-10" data-id="element-563" data-mp="p3jtqw2b43gf">
        <DeliverableGroups data-id="element-564" data-mp="k3fndyv44p3x" />
      </div>
    </div>;
}